import { gridSize } from '../shared-variables';

var fullWidth = '100vw';
var narrowWidth = 45 * gridSize;
var wideWidth = 75 * gridSize;

export var boxShadowSpread = gridSize * 4;
export var animationSpeed = '220ms';
export var animationTiming = 'cubic-bezier(0.15, 1, 0.3, 1)';
export var widthTransition = 'width ' + animationSpeed + ' ' + animationTiming;
export var drawerBackIconSize = gridSize * 5;

export var widths = {
  narrow: {
    width: narrowWidth + 'px',
    offScreenTranslateX: -narrowWidth - boxShadowSpread + 'px'
  },
  wide: {
    width: wideWidth + 'px',
    offScreenTranslateX: -wideWidth - boxShadowSpread + 'px'
  },
  full: {
    width: fullWidth,
    offScreenTranslateX: 'calc(-' + fullWidth + ' - ' + boxShadowSpread + 'px)'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/utils/drawer-style-variables.js
// module id = 172
// module chunks = 0